document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);

  const TARGET_VARIANT_ID = '42742181101740';

  const apply = () => {
    const currentVariant = document.querySelector('[name="id"]')?.value;
    if (currentVariant !== TARGET_VARIANT_ID) return false;

    if (params.get('subscribe') === '1') {
      const sub = document.querySelector('#subscription');

      if (sub) {
        sub.checked = true;
        sub.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }

    return false;
  };

  // 即時トライ
  if (apply()) return;

  // DOM生成待ち
  const observer = new MutationObserver(() => {
    if (apply()) observer.disconnect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});